import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { SaveCuentaDto, Cuenta, Moneda, Banco, MenuFuncionCodes, SearchBancoRequest, Proveedor, Persona, Comunidad, Consorcio, UnidadFuncional, DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, SearchUnidadFuncionalRequest, SearchComunidadRequest, SearchConsorcioRequest, SearchProveedorRequest, TenantFeatureFlags, LocalStorageKeys, GetSaldoRequestDto, SearchTipoDocumentoRequest, TipoDocumento, SearchPersonaRequestDto } from '../../../../src/app/shared/model/index';
import { SearchMonedaRequest, DialogConfirmRequest, DialogConfirmResponse } from '../../../../src/app/shared/model/index';

import { CuentaService, MenuFuncionService, BancoService, MonedaService, PersonaService, ProveedorService, ComunidadService, ConsorcioService, UnidadFuncionalService, TenantService, MovimientoService, TipoDocumentoService } from '../../shared/services';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogPersonaSearchComponent } from '../usuarios/components/dialogPersonaSearch.component';

@Component({
    selector: 'app-cuentaEdit',
    templateUrl: './cuentaEdit.component.html',
    styleUrls: []
})

export class CuentaEditComponent implements OnInit {
    formGroup: FormGroup;
    proveedorFormGroup: FormGroup;
    personaFormGroup: FormGroup;

    tenantFeatureFlags: TenantFeatureFlags;

    isValidating: boolean = false;
    isSearching: boolean = false;
    isSaving: boolean = false;
    isDeleting: boolean = false;
    canViewSaldo: boolean = false;
    
    isBancoSearching: boolean = false;
    isMonedaSearching: boolean = false;
    isPersonaSearching: boolean = false;
    isProveedorSearching: boolean = false;
    isComunidadSearching: boolean = false;
    isConsorcioSearching: boolean = false;
    isUnidadesFuncionalesSearching: boolean = false;
    isProveedorAutoSearching: boolean = false;
    isTipoDocumentoSearching: boolean = false;
    
    showCuit: boolean = false;
    nuevaPersona: boolean = false;
    canPersonaAdd: boolean = false;
    canAdd: boolean = false;
    canEdit: boolean = false;
    canDelete: boolean = false;
    canView: boolean = false;
    canTenantAdmin: boolean = false;
    canAsociarPersona: boolean = false;
    canAsociarProveedor: boolean = false;
    canAsociarConsorcio: boolean = false;
    canAsociarComunidad: boolean = false;
    canAsociarUnidadFuncional: boolean = false;
    isCuentaSaldoSearching: boolean = false;
    isPersonaDataSearching: boolean = false;

    msgError: string = "";
    selectedTabIndex: number = 0;

    tipoDocumentoList: TipoDocumento[];
    filteredProveedorList: Proveedor[];
    consorcioList: Consorcio[];
    comunidadList: Comunidad[];
    ufComunidadList: Comunidad[];
    monedasList: Moneda[];
    bancosList: Banco[];
    ufList: UnidadFuncional[];

    item: Cuenta;

    persona: Persona | null;
    proveedor: Proveedor | null;
    comunidad: Comunidad | null;
    consorcio: Consorcio | null;
    ufComunidad: Comunidad | null;
    unidadFuncional: UnidadFuncional | null;
    personaSearchResult: Persona | null;

    cuentaSaldo: any;

    constructor(
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        private location: Location,
        private route: ActivatedRoute,
        private sharedFunctions: SharedFunctions,
        private tenantService: TenantService,
        private bancoService: BancoService,
        private menuFuncionService: MenuFuncionService,
        private personaService: PersonaService,
        private proveedorService: ProveedorService,
        private comunidadService: ComunidadService,
        private consorcioService: ConsorcioService,
        private unidadFuncionalService: UnidadFuncionalService,
        private cuentaService: CuentaService,
        private monedaService: MonedaService,
        private tipoDocumentoService: TipoDocumentoService,
        private movimientoService: MovimientoService
    ) { }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.CUENTA).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.menuFuncionService.checkMenu(MenuFuncionCodes.TENANT_ADMIN).subscribe(dataTenant2 => {
                    if (dataTenant2 != null && dataTenant2.Success && dataTenant2?.Result)
                        this.canTenantAdmin = true;

                    this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
                        this.isValidating = false;
                        if (dataTenant != null && dataTenant.Success)
                            this.tenantFeatureFlags = dataTenant.Result;
                
                        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.CUENTA_EDIT);
                        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.CUENTA_ADD);
                        this.canView = data.Result.some(x => x == MenuFuncionCodes.CUENTA_LIST);
                        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.CUENTA_DELETE);

                        this.loadView();
                    },
                    (err: HttpErrorResponse) => {
                        this.isValidating = false;
                        this.sharedFunctions.handleError(err, true);
                    })
                },
                (err: HttpErrorResponse) => {
                    this.isValidating = false;
                    this.sharedFunctions.handleError(err, true);
                });
            }
            else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.onCancel();
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }
    
    loadView() {
        this.loadTabPermisos();

        this.menuFuncionService.checkMenu(MenuFuncionCodes.PERSONA_ADD).subscribe(data => {
            if (data != null && data.Success && data?.Result)
              this.canPersonaAdd = true;
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });

        this.getMonedas();
        this.getBancos();

        this.buildForm();
        this.loadEntity();

        if (this.canAdd || this.canEdit) {
            this.getComunidades();
            this.getConsorcios();
        }
    }

    loadTabPermisos() {
        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data.Result != null)
                this.canAsociarPersona = data.Result.length > 0;

            this.getTiposDocumento();
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        })

        if (this.tenantFeatureFlags.HabilitarGestionConsorcio) {
            this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.CONSORCIO).subscribe(data => {
                this.isValidating = false;
                if (data != null && data.Success && data.Result != null)
                    this.canAsociarConsorcio = data.Result.length > 0;
            },
            (err: HttpErrorResponse) => {
                this.sharedFunctions.handleError(err);
            })
        }

        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.COMUNIDAD).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data.Result != null)
                this.canAsociarComunidad = data.Result.length > 0;
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        })

        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.PROVEEDOR).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data.Result != null)
                this.canAsociarProveedor = data.Result.length > 0;

            if (this.canAsociarProveedor)
                this.getProveedoresAutocomplete();
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        })

        if (this.tenantFeatureFlags.HabilitarGestionUf) {
            this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
                this.isValidating = false;
                if (data != null && data.Success && data.Result != null)
                    this.canAsociarUnidadFuncional = data.Result.length > 0;
            },
            (err: HttpErrorResponse) => {
                this.sharedFunctions.handleError(err);
            })
        }
    }

    buildForm() {
        this.formGroup = this.formBuilder.group({
            'Codigo': [null, [Validators.maxLength(100)]],
            'BancoId': [null],
            'MonedaId': [null, Validators.required],
            'ClaveBancaria': [null, [Validators.maxLength(100)]],
            'NumeroCuenta': [null, Validators.maxLength(100)],
            'Titular': [null, Validators.maxLength(100)],
            'Alias': [null, [Validators.required,  Validators.maxLength(100)]]
        });

        this.proveedorFormGroup = this.formBuilder.group({
            'Proveedor': [null]
        });
    }

    buildPersonForm() {
        this.personaFormGroup = this.formBuilder.group({
          'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
          'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
          'TipoDocumentoId': [null],
          'NroDocumento': [null, Validators.maxLength(100)],
          'Cuit': [null, Validators.maxLength(100)],
          'FechaNacimiento': [null],
          'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
          'MovilContacto': [null, Validators.maxLength(100)]
        });
    }

    isProcessing() {
        return (this.isSearching || this.isSaving || this.isDeleting);
    }

    loadEntity() {
        
        this.route.params.subscribe(params => {
     
            if (params['id'] != null && params['id'] > 0) {
                var id = params['id'];
                if (id != null && id > 0) {
                    this.isSearching = true;
                    this.cuentaService.get(id).subscribe(data => {
                        this.isSearching = false;
                        if (data != null && data.Success) {
                            this.item = data.Result;

                            if (this.item != null && this.item.Id > 0) {
                                this.canViewSaldo = (this.tenantFeatureFlags?.HabilitarControlCaja);
                                this.canEdit = this.canEdit && (this.canTenantAdmin || !this.item.EsCuentaCorrienteInterna);
                                this.canDelete = this.canDelete && (this.canTenantAdmin || !this.item.EsCuentaCorrienteInterna);

                                if (this.canEdit) {
                                    this.formGroup.patchValue(this.item);
                                    this.onCuentaCorrienteInternaChange();

                                    if (this.item.PersonaId != null && this.item.PersonaId > 0)
                                        this.selectedTabIndex = 0;

                                    if (this.item.ProveedorId != null && this.item.ProveedorId > 0) {
                                        this.selectedTabIndex = 1;
                                        this.filteredProveedorList = [new Proveedor
                                        (
                                            this.item.ProveedorId, null,
                                            this.item.Proveedor,
                                            null,null,null,null,null,null,null,null,null,true,null,null,null,null,[]
                                        )];
                                        this.proveedorFormGroup.get("Proveedor")?.setValue(this.filteredProveedorList[0]);
                                    }

                                    if (this.item.ComunidadId != null && this.item.ComunidadId > 0)
                                        this.selectedTabIndex = 3;

                                    if (this.item.ConsorcioId != null && this.item.ConsorcioId > 0)
                                        this.selectedTabIndex = 2;

                                    if (this.item.UnidadFuncionalId != null && this.item.UnidadFuncionalId > 0)
                                        this.selectedTabIndex = 4;
                                }

                                this.loadPersona(this.item.PersonaId ?? 0);
                                this.loadProveedor(this.item.ProveedorId ?? 0);
                                this.loadComunidad(this.item.ComunidadId ?? 0);
                                this.loadConsorcio(this.item.ConsorcioId ?? 0);
                                this.loadUnidadFuncional(this.item.UnidadFuncionalId ?? 0);

                                this.getCuentaSaldo();
                            }
                            else
                                this.msgError = "No se encontró la cuenta seleccionada.";
                        }
                        else
                            this.msgError = "Ocurrió un error al intentar obtener los datos de la cuenta.";
                    },
                    (err: HttpErrorResponse) => {
                        this.isSearching = false;
                        this.sharedFunctions.handleError(err, true);
                    })
                }
            }
            else {
                this.canEdit = true;
                this.item = new Cuenta(0, null, false, null, null, null, null, null, null, null, null, true, null, null, null, null, null, null, null, null, null, null);
                this.formGroup.patchValue(this.item);
            }
        });

    }

    loadPersona(personaId: number) {
        if (personaId != null && personaId > 0) {
            this.isPersonaSearching = true;
            this.personaService.get(personaId).subscribe(data => {
                this.isPersonaSearching = false;
                if (data != null && data.Success) {
                    this.persona = data.Result;
                }
            },
            (err: HttpErrorResponse) => {
                this.isPersonaSearching = false;
                this.sharedFunctions.handleError(err);
            })
        }
    }

    loadProveedor(proveedorId: number) {
        if (proveedorId != null && proveedorId > 0) {
            this.isProveedorSearching = true;
            this.proveedorService.get(proveedorId).subscribe(data => {
                this.isProveedorSearching = false;
                if (data != null && data.Success) {
                    this.proveedor = data.Result;
                }
            },
            (err: HttpErrorResponse) => {
                this.isProveedorSearching = false;
                this.sharedFunctions.handleError(err);
            })
        }
    }

    loadComunidad(comunidadId: number) {
        if (comunidadId != null && comunidadId > 0) {
            this.isComunidadSearching = true;
            this.comunidadService.get(comunidadId).subscribe(data => {
                this.isComunidadSearching = false;
                if (data != null && data.Success) {
                    this.comunidad = data.Result;
                }
            },
            (err: HttpErrorResponse) => {
                this.isComunidadSearching = false;
                this.sharedFunctions.handleError(err);
            })
        }
    }

    loadConsorcio(consorcioId: number) {
        if (consorcioId != null && consorcioId > 0) {
            this.isConsorcioSearching = true;
            this.consorcioService.get(consorcioId).subscribe(data => {
                this.isConsorcioSearching = false;
                if (data != null && data.Success) {
                    this.consorcio = data.Result;
                }
            },
            (err: HttpErrorResponse) => {
                this.isConsorcioSearching = false;
                this.sharedFunctions.handleError(err);
            })
        }
    }

    loadUnidadFuncional(ufId: number) {
        if (ufId != null && ufId > 0) {
            this.isUnidadesFuncionalesSearching = true;
            this.unidadFuncionalService.get(ufId).subscribe(data => {
                this.isUnidadesFuncionalesSearching = false;
                if (data != null && data.Success) {
                    this.unidadFuncional = data.Result;

                    if (this.unidadFuncional.ComunidadId != null && this.unidadFuncional.ComunidadId > 0) {
                        var r = new SearchUnidadFuncionalRequest(null, null, true, "", null, null, null, null, null, null, this.unidadFuncional.ComunidadId, null, true);
                        this.isUnidadesFuncionalesSearching = true;

                        this.unidadFuncionalService.search(r).subscribe(data => {
                            this.isUnidadesFuncionalesSearching = false;
                            this.ufList = data.result;
                        },
                        (err: HttpErrorResponse) => {
                            this.isUnidadesFuncionalesSearching = false;
                            this.sharedFunctions.handleError(err,);
                        })

                        this.comunidadService.get(this.unidadFuncional.ComunidadId).subscribe(data => {
                            if (data != null && data.Success) {
                                this.ufComunidad = data.Result;
                            }
                        },
                        (err: HttpErrorResponse) => {
                            this.sharedFunctions.handleError(err);
                        })
                    }
                }
            },
            (err: HttpErrorResponse) => {
                this.isUnidadesFuncionalesSearching = false;
                this.sharedFunctions.handleError(err);
            })
        }
    }

    compareComunidades(o1: Comunidad, o2: Comunidad): boolean {
        return o1?.Id == o2?.Id;
    }

    compareConsorcios(o1: Consorcio, o2: Consorcio): boolean {
        return o1?.Id == o2?.Id;
    }

    compareUfs(o1: UnidadFuncional, o2: UnidadFuncional): boolean {
        return o1?.Id == o2?.Id;
    }

    getCuentaSaldo() {
        var r = new GetSaldoRequestDto(this.item.Id, null, null, null, null, null, null);
          this.isCuentaSaldoSearching = true;
          this.movimientoService.getSaldo(r).subscribe(data => {
            this.isCuentaSaldoSearching = false;
            if (data != null && data.Success && data.Result != null && data.Result.Saldos != null && data.Result.Saldos.length > 0) {
              this.cuentaSaldo = { Saldo: data.Result.Saldos[0].SaldoAFavor, Moneda: data.Result.Saldos[0].Moneda };
            }
            else {
                this.cuentaSaldo = { Moneda: "Sin saldo disponible", Saldo: null };
            }
        },
        (err: HttpErrorResponse) => {
        this.isCuentaSaldoSearching = false;
        this.sharedFunctions.handleError(err, true);
        })
    }

    onCuentaCorrienteInternaChange() {
        const aliasControl = this.formGroup.get('Alias');
        if (aliasControl != null) {
            if (this.item.EsCuentaCorrienteInterna)
                aliasControl.setValidators(null);
            else
                aliasControl.setValidators([Validators.required]);
            aliasControl.updateValueAndValidity();
        }
    }

//#region Getters

    getTiposDocumento() {
        if (!this.canAsociarPersona)
            return false;

        var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
        this.isTipoDocumentoSearching = true;

        this.tipoDocumentoService.search(r).subscribe(data => {
            this.isTipoDocumentoSearching = false;
            this.tipoDocumentoList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isTipoDocumentoSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getProveedoresAutocomplete() {
        if (!this.canAsociarProveedor)
            return false;

        this.proveedorFormGroup.get('Proveedor')?.valueChanges
            .pipe(
                filter(res => {
                    return res && res !== null && res.length >= 3
                }),
                distinctUntilChanged(),
                debounceTime(1000),
                tap(() => {
                    this.filteredProveedorList = [];
                    this.isProveedorAutoSearching = true;
                }),
                switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
                    .pipe(
                    finalize(() => {
                        this.isProveedorAutoSearching = false;
                    }),
                    )
                )
            )
            .subscribe((data: any) => {
            this.isProveedorAutoSearching = false;
            if (data != null && data.result != null){
                this.filteredProveedorList = data.result;
            }
            else
                this.filteredProveedorList = [];
            });
    }

    displayProveedor(proveedor: Proveedor): string {
        return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
    }

    getConsorcios() {
        if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
            return;

        var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
        this.isConsorcioSearching = true;

        this.consorcioService.search(r).subscribe(data => {
            this.isConsorcioSearching = false;
            this.consorcioList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isConsorcioSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getComunidades() {
        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
        this.isComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
            this.isComunidadSearching = false;
            this.comunidadList = data?.result;
            this.ufComunidadList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

//#endregion

//#region Metodos Persona

    onTipoDocumentoSelection() {
        var tipoDoc: TipoDocumento | null = null;
        if (this.tipoDocumentoList != null)
            tipoDoc = (this.tipoDocumentoList.filter(f => f.Id == this.personaFormGroup?.get("TipoDocumentoId")?.value))[0];
        this.showCuit = !(tipoDoc?.Nombre?.toUpperCase() == "CUIT" || tipoDoc?.Nombre?.toUpperCase() == "CUIL");
        this.checkPersonaExistance(true, false);
    }

    onNroDocumentoChange() {
        this.checkPersonaExistance(true, false);
    }

    onCuitChange() {
        this.checkPersonaExistance(false, true);
    }

    checkPersonaExistance(searchByDoc: boolean, searchByCuit: boolean) {
        var tipoDocId = this.personaFormGroup?.get("TipoDocumentoId")?.value;
        var nroDoc = this.personaFormGroup?.get("NroDocumento")?.value;
        var cuit = this.personaFormGroup?.get("Cuit")?.value;

        if ((tipoDocId > 0 && nroDoc?.length > 0) || cuit?.length > 0) {
            var r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, tipoDocId, nroDoc, null, null, null, true, false);
            if (searchByCuit)
            r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, null, null, cuit, null, null, true, false);
            
            this.isPersonaDataSearching = true;

            this.personaService.search(r).subscribe(data => {
                this.isPersonaDataSearching = false;
                if (data != null && data.result != null && data.result.length > 0) {
                    this.personaSearchResult = data?.result[0];

                    if (this.personaSearchResult?.Id == this.persona?.Id) {
                        this.personaSearchResult = null;
                        return;
                    }

                    var msg = "Se encontró a la persona " + this.personaSearchResult?.Nombre + " " + this.personaSearchResult?.Apellido;
                    if (searchByDoc) msg +=" en base al tipo y nro. de documento ingresado. ";
                    if (searchByCuit) msg +=" en base al CUIT/CUIL ingresado. ";
                    msg += "\n\n¿Desea cargar los datos encontrados?"

                    const dialogRef = this.dialog.open(DialogConfirmComponent, {
                        data: new DialogConfirmRequest("Persona encontrada", msg, "Sí, carga los datos", "No cargues nada")
                    });

                    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
                        if (result != null && result.Accepted)
                            this.cargarPersonaEncontrada();
                        else
                            this.noCargarPersonaEncontrada();
                    });
                }
            },
            (err: HttpErrorResponse) => {
                this.isPersonaDataSearching = false;
                this.sharedFunctions.handleError(err);
            });
        }
    }

    cargarPersonaEncontrada() {
        if (this.personaSearchResult != null && this.personaSearchResult.Id > 0) {
            if (this.item != null)
                this.item.PersonaId = this.personaSearchResult.Id;
            this.persona = this.personaSearchResult;

            this.personaSearchResult = null;
            this.nuevaPersona = false;
        }
    }

    noCargarPersonaEncontrada() {
        this.personaSearchResult = null;
    }

//#endregion

//#region Seleccion

    onPersonSearchClick() {
        const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
            width: '90%',
            data: new DialogPersonaSearchComponentRequestDto(false, 0)
        });

        dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
            if (result != null && !result.Cancelled) {
                var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);

                this.persona = new Persona(0, null, null, null, null, null, null, null, null, null, true, null, null, null);
                if (u != null && u.Id > 0)
                    this.persona = new Persona(u.Id, u.Nombre, u.Apellido, u.NroDocumento, u.TipoDocumentoNombre, u.TipoDocumentoId, u.FechaNacimiento, u.Cuit, u.MailContacto, u.MovilContacto,
                    u.Activo, u.FotoDniFrenteUrl, u.FotoDniDorsoUrl, u.FotoSelfieUrl);
            }
        });
    }

    onNewPersonClick() {
        this.nuevaPersona = true;
        this.persona = new Persona(0, null, null, null, null, null, null, null, null, null, true, null, null, null);

        this.buildPersonForm();
    }

    onProveedorSelect() {
        this.proveedor = this.proveedorFormGroup?.get("Proveedor")?.value;

        this.persona = null;
        this.comunidad = null;
        this.consorcio = null;
        this.unidadFuncional = null;
        this.ufComunidad = null;
    }

    onPersonaSelect() {
        this.proveedor = null;
        this.comunidad = null;
        this.consorcio = null;
        this.unidadFuncional = null;
        this.ufComunidad = null;
    }

    onComunidadSelect() {
        this.persona = null;
        this.proveedor = null;
        this.consorcio = null;
        this.unidadFuncional = null;
        this.ufComunidad = null;
    }

    onConsorcioSelect() {
        this.persona = null;
        this.proveedor = null;
        this.comunidad = null;
        this.unidadFuncional = null;
        this.ufComunidad = null;
    }

    onUfComunidadSelect() {
        this.unidadFuncional = null;
        if (this.ufComunidad == null || this.ufComunidad.Id == null || this.ufComunidad.Id <= 0) {
            this.ufList = [];
            return false;
        }

        var r = new SearchUnidadFuncionalRequest(null, null, true, "", null, null, null, null, null, null, this.ufComunidad?.Id, null, true);
        this.isUnidadesFuncionalesSearching = true;

        this.unidadFuncionalService.search(r).subscribe(data => {
            this.isUnidadesFuncionalesSearching = false;
            this.ufList = data.result;
        },
        (err: HttpErrorResponse) => {
            this.isUnidadesFuncionalesSearching = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    onUnidadFuncionalSelect() {
        this.persona = null;
        this.proveedor = null;
        this.comunidad = null;
        this.consorcio = null;
    }

//#endregion

    onGuardar() {
        if (!this.formGroup.valid) {
            this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
            return false;
        }

        var result = new SaveCuentaDto(0, null, 0, null, this.persona?.Id ?? null, this.proveedor?.Id ?? null, this.comunidad?.Id ?? null, this.consorcio?.Id ?? null,
            this.unidadFuncional?.Id ?? null, null, null, null, null, true, false);
    
        result =
        {
            ...result,
            ...this.formGroup.value,
            Id: (this.item?.Id ?? 0),
            Activo: (this.item?.Activo ?? true),
            EsCuentaCorrienteInterna: (this.item?.EsCuentaCorrienteInterna ?? false),
            Persona: this.personaFormGroup?.getRawValue()
        };

        this.isSaving = true;
        this.cuentaService.save(result).subscribe(data => {
            this.isSaving = false;
            if (data != null && data.Success && data.Result != null && data.Result.Id != null) {
                this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
                this.onCancel();
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isSaving = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    onDelete() {
        if (!this.canDelete)
            return false;

        const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest
            (
                null,
                "¿Está seguro que desea dar de baja el item?",
                "Sí",
                "No"
            )
        });

        dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {

            if (result.Accepted) {
                this.item.Activo = false;
                this.isDeleting = true;

                this.cuentaService.delete(this.item.Id).subscribe(data => {
                    this.isDeleting = false;
                    if (data != null && data.Success) {
                        this.sharedFunctions.showMessage("Se dió de baja correctamente el item!", "Operación Exitosa!");
                        this.onCancel();
                    }
                    else
                        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
                },
                (err: HttpErrorResponse) => {
                    this.isDeleting = false;
                    this.sharedFunctions.handleError(err, true);
                });
            }
        });
    }

    getErrorCodigo() {
        var v = this.formGroup.get('Codigo');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
          return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorClaveBancaria() {
        var v = this.formGroup.get('ClaveBancaria');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
          return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorNumeroCuenta() {
        var v = this.formGroup.get('NumeroCuenta');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
          return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorTitular() {
        var v = this.formGroup.get('Titular');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
          return 'Límite de 100 caracteres alcanzado';
        return '';
    }
    
    getErrorAlias() {
        var v = this.formGroup.get('Alias');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorMoneda() {
        var v = this.formGroup.get('MonedaId');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        return '';
    }

    getBancos() {
        var r = new SearchBancoRequest(null, null, true, "Nombre", null, null, null, true);
        this.isBancoSearching = true;

        this.bancoService.search(r).subscribe(data => {
            this.isBancoSearching = false;
            this.bancosList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isBancoSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getMonedas() {
        var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
        this.isMonedaSearching = true;

        this.monedaService.search(r).subscribe(data => {
            this.isMonedaSearching = false;
            this.monedasList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isMonedaSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    onCancel() {
        this.location.back();
    }
}
